;
define("header_logo.tpl", function(){});

